import { render, staticRenderFns } from "./RicohHybridMail.vue?vue&type=template&id=acb01b62&scoped=true&"
import script from "./RicohHybridMail.vue?vue&type=script&lang=js&"
export * from "./RicohHybridMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb01b62",
  null
  
)

export default component.exports